// extracted by mini-css-extract-plugin
module.exports = {"image":"AddOnCard_image__2lvzi","content":"AddOnCard_content__AuOLj"};